common.View.create('shop::Habitats.Website.Modules.ShopCheckout.Cart.Index', {

    onDOMLoad()
    {

    },

    setLoading()
    {
        this.element

            // Show loading.
            .addClass('loading')

            // Disable inputs.
            .find('input')
                .attr('readonly', true)
                .end()

            // Disable buttons.
            .find('button')
                .attr('disabled', true)
                .end();
    },

    setHtml(html)
    {
        // Replace with element to find.
        this.element.replaceWith($(html).find('.shop\\:\\:Habitats-Website-Modules-ShopCheckout-Cart-Index'));

        //
        common.View.reinit();
    },

});
